import { Button } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'

import qrCodePreview from 'assets/images/cms/qr-code-preview.png'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('cms.settings.scannable_codes')

type Props = {
  isSubmitting: boolean
  formDisabled: boolean
  handleSubmit: () => void
}

const Sidebar = ({ isSubmitting, formDisabled, handleSubmit }: Props) => {
  const [css] = useStyletron()

  return (
    <>
      <Button
        className="mb-xxl px-s w-100"
        onClick={handleSubmit}
        isLoading={isSubmitting}
        disabled={formDisabled}
      >
        {t('publish')}
      </Button>
      <img
        className={`mb-xl ${css({
          width: '200px',
          height: '397px',
        })}`}
        src={qrCodePreview}
        alt={t('qr_code_preview')}
      />
    </>
  )
}

export default Sidebar
